<template>
  <div>
    <template v-if="!hasFCPAccess">
      <h4 class="font-weight-bold text-center">Permission denied.</h4>
      <p class="mb-0 text-sm text-center">You do not have valid FCP access.</p>
    </template>
    <slot v-else name="default" />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

import { useCurrentUser } from "@composables";

export default defineComponent({
  name: "FCPWrapper",
  setup() {
    const { hasFCPAccess } = useCurrentUser();

    return {
      hasFCPAccess,
    };
  },
});
</script>
